import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { EASE, Reveal } from "@/components/Reveal";

export const EditorialSplit = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="editorial-split" className="border-y">
      <div className="grid md:grid-cols-2">
        <motion.div
          className="relative"
          initial={reduce ? false : "hidden"}
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          <motion.div
            className="relative grid aspect-[4/5] place-items-center overflow-hidden bg-[#111111] md:aspect-auto md:h-full md:min-h-[100svh]"
            variants={{ hidden: { clipPath: "inset(0% 0% 0% 100%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
            transition={{ duration: 1.3, ease: EASE }}
          >
            <motion.img
              src="/img/sviin-2026-v2.webp"
              alt="Sviin 2026 vintage stamp"
              loading="lazy"
              style={{ y }}
              className="w-[68%] max-w-[520px] object-contain"
            />
          </motion.div>
        </motion.div>
        <div className="flex flex-col justify-between gap-16 border-t px-4 py-16 md:border-l md:border-t-0 md:px-14 md:py-20 lg:px-20">
          <Reveal>
            <p className="label text-[#111111]/60">( The idea )</p>
          </Reveal>
          <div>
            <Reveal>
              <h2 className="font-['Geist',sans-serif] text-5xl font-light leading-[1.02] tracking-[-0.04em] sm:text-6xl lg:text-7xl">
                Bigger than just clothing
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-10 max-w-md text-base leading-relaxed text-[#111111]/75">
                Every piece is carefully thought out and made with intention. Nothing rushed, nothing random — each design
                is curated with purpose, so what you wear carries meaning.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="flex items-center justify-between border-t pt-6">
            <Link to="/about" data-testid="editorial-about-link" className="label draw-link hover:text-[#E2541B]">Our approach</Link>
            <span className="label text-[#111111]/60">Est. 2026</span>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
